import { Box, Button, Link, Menu, Typography } from "@mui/material";
import React, { useState } from "react";
import { useWindowDimensions } from "../../shared/hooks/useWindowDimensions";
import { useNavigate } from "react-router-dom";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import DatePicker from "../../shared/components/date_picker";
import { styled } from "@mui/material/styles";

const StyledMenu = styled((props) => (
  <Menu
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: "0.5rem",
    "& .MuiMenu-list": {
      padding: "0",
    },
  },
}));

function Header(props) {
  const { fleetId, selectedFleet, fromDate, toDate, setDateRange } = props;
  const navigate = useNavigate();
  const windowSize = useWindowDimensions();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const confirm = (newFromDate, newToDate) => {
    if (
      newFromDate.getDate() === newToDate.getDate() &&
      newFromDate.getMonth() === newToDate.getMonth() &&
      newFromDate.getFullYear() === newToDate.getFullYear()
    ) {
      setDateRange(newFromDate, null);
    } else {
      setDateRange(newFromDate, newToDate);
    }
    handleClose();
  };

  return (
    <React.Fragment>
      <Box display={"flex"} sx={{ padding: "1.5rem" }}>
        <Box display={"flex"} sx={{ flexDirection: "column", flexGrow: 1 }}>
          <Box
            display={"flex"}
            style={{
              gap: 5,
              alignItems: "center",
              maxWidth: windowSize.width - 48,
            }}
          >
            <Link
              component="button"
              onClick={() => {
                navigate("/home/" + fleetId);
              }}
              underline="none"
              style={{ color: "white" }}
            >
              Home
            </Link>
            <Typography color="white">/</Typography>
            <Link
              component="button"
              onClick={() => {
                navigate("/report/" + fleetId);
              }}
              underline="none"
              style={{ color: "white" }}
              noWrap
            >
              {selectedFleet ? selectedFleet.name : "N/A"}
            </Link>
            <Typography color="white">/</Typography>
            <Link
              component="button"
              underline="none"
              style={{ color: "white" }}
              noWrap
            >
              Fleet Report -
              {" " +
                fromDate.toLocaleString("en-US", {
                  month: "short",
                  day: "numeric",
                })}
              {toDate === null ||
              toDate.getFullYear() !== fromDate.getFullYear()
                ? ", " +
                  fromDate.toLocaleString("en-US", {
                    year: "numeric",
                  })
                : ""}
              {toDate !== null
                ? " - " +
                  toDate.toLocaleString("en-US", {
                    month: "short",
                    day: "numeric",
                  }) +
                  ", " +
                  toDate.toLocaleString("en-US", {
                    year: "numeric",
                  })
                : ""}
            </Link>
          </Box>
          <Box>
            <Typography variant="h4" color={"white"}>
              {selectedFleet ? selectedFleet.name : "N/A"}
            </Typography>
            <Typography color="#a0a7b0" variant="body1">
              {selectedFleet ? selectedFleet.address : "N/A"}
            </Typography>
          </Box>
        </Box>
        <Box display={"flex"} sx={{ alignItems: "flex-end" }}>
          <Button
            color="secondary"
            variant="contained"
            endIcon={<CalendarMonthOutlinedIcon />}
            id="date-picker-menu-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            Select date
          </Button>
          <StyledMenu
            id="date-picker-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "date-picker-menu-button",
            }}
            sx={{ padding: 10 }}
          >
            <DatePicker
              type={"range"}
              cancel={handleClose}
              confirm={confirm}
              ogStartDate={fromDate}
              ogEndDate={toDate}
            />
          </StyledMenu>
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default Header;
